import { useContext } from "react";
import { clearToken, getUserData } from "./userFunctions";
import { UserContext } from "./userContext";

const useUser = () => {
    const usuario = useContext(UserContext);


    async function carregarUsuario() {
        try {
            usuario?.setLoadingUser(true);

            let resp = await getUserData();

            if (resp.error === false) {
                usuario?.setUser(resp.data);
            }
        }
        finally {
            usuario?.setLoadingUser(false);
        }
    }


    const getUser = () => {
        let usr = usuario?.user;
        if (usr === null || usr === undefined)
            carregarUsuario();
        else
            return usuario?.user;
    }

    const clear = () => {
        clearToken();
        localStorage.clear();
        usuario?.setUser(null);
    }

    return { user: usuario?.user, loadingUser: usuario?.loadingUser, clear, getUser }
}

export default useUser;
